module.exports = __webpack_public_path__ + "static/media/detail17.45ede6f6.jpg";